// Footer.jsx
// Place these image files in: src/assets/
// - footer-trusted.webp
// - tag1.webp
// - tag2.webp

import React from 'react';
import trustedBadge from '../assets/footer-trusted.webp';
import tag1 from '../assets/tag1.webp';
import tag2 from '../assets/tag2.webp';

const Footer = ({
  companyName = 'Aao Hukum.',
  address = 'F-3, Plot No. 20, Aditya Plaza, Shree Ram Nagar, Khirani Phatak Raad, Jhotwara, Jaipur, Raj. , 302012',
  phonee = '+91 7597700113',
  phone = '+91 7339700107',
  email = 'sales@aaohukum.com',
}) => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-8 min-h-[360px]">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">

          {/* About */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold mb-3 text-[#E91E63]">About Us</h3>
            <p className="text-sm text-gray-300 leading-relaxed mb-4">
              As a premier tour and travel company, we are dedicated to delivering exceptional travel experiences. Our greatest reward lies in the trust and satisfaction of the many clients we proudly serve.
            </p>

            <div className="flex flex-wrap gap-3">
              <span className="bg-emerald-500/20 text-emerald-400 px-3 py-1 rounded-full text-xs font-medium">50K+ Travelers</span>
              <span className="bg-yellow-500/20 text-yellow-400 px-3 py-1 rounded-full text-xs font-medium">4.9/5 Rating</span>
              <span className="bg-blue-500/20 text-blue-400 px-3 py-1 rounded-full text-xs font-medium">Award Winning</span>
            </div>
          </div>

          {/* Guaranteed & Certified */}
          <div className="grid grid-cols-1 gap-6 col-span-2">
            <div className="sm:text-center">
              <h3 className="text-lg font-bold mb-3 text-[#E91E63]">Guaranteed & Certified</h3>

              <div className="flex sm:justify-center items-center gap-4 mb-3 flex-col sm:flex-row">
                <img
                  src={trustedBadge}
                  alt="Guarantee badge with trust, support, value, and security"
                  width={120}
                  height={120}
                  className="w-[100px] h-[100px] object-contain"
                  loading="lazy"
                />

                <div className="flex justify-center gap-3">
                  <img src={tag1} alt="Best Price Quality badge" width={60} height={60} className="w-[60px] h-[60px] object-contain" loading="lazy" />
                  <img src={tag2} alt="Approved badge" width={60} height={60} className="w-[60px] h-[60px] object-contain" loading="lazy" />
                </div>
              </div>
            </div>
          </div>

          {/* Address & Contact */}
          <div>
            <h3 className="text-lg font-bold mb-3 text-[#E91E63]">Address & Contact</h3>

            <div className="space-y-2 text-sm text-gray-300">
              <p className="flex items-center gap-2">
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" className="w-4 h-4 text-[#E91E63]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path d="M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"></path>
                </svg>
                {address}
              </p>

              <div className="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-[#E91E63]" aria-hidden="true">
                  <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
                </svg>
                <a href={`tel:${phone}`} className="hover:underline">{phone}</a>
              </div>
                <div className="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-[#E91E63]" aria-hidden="true">
                  <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
                </svg>
                <a href={`tel:${phonee}`} className="hover:underline">{phonee}</a>
              </div>
              <div className="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-[#E91E63]" aria-hidden="true">
                  <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                  <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                </svg>
                <a href={`mailto:${email}`} className="hover:underline">{email}</a>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-700 mt-6 pt-4 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-gray-400">© {year} {companyName}. All rights reserved.</p>

          <div className="flex items-center gap-1 min-w-[70px]">
            {[1,2,3,4,5].map((i) => (
              <svg key={i} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3 fill-yellow-400 text-yellow-400" aria-hidden="true">
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
              </svg>
            ))}

            <span className="text-xs text-gray-400 ml-1">4.9/5</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
